document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.zkx').forEach((root) => {
    const sectionId = root.dataset.sectionId || '';

    const slider = root.querySelector(`#zkx-slider-${sectionId}`);
    const slides = root.querySelector(`#zkx-slides-${sectionId}`);
    const progressBar = root.querySelector(`#zkx-progress-bar-${sectionId}`);
    const progressLabel = root.querySelector(`#zkx-progress-label-${sectionId}`);

    const backBtn = root.querySelector(`#zkx-back-${sectionId}`);
    const nextBtn = root.querySelector(`#zkx-next-${sectionId}`);
    const mobileBackBtn = root.querySelector(`#zkx-mobile-back-${sectionId}`);
    const mobileNextBtn = root.querySelector(`#zkx-mobile-next-${sectionId}`);
    const mobileSticky = root.querySelector(`#zkx-mobile-sticky-${sectionId}`);

    const goOfferBtn = root.querySelector(`#zkx-go-offer-${sectionId}`);
    const submitBtn = root.querySelector(`#zkx-submit-${sectionId}`);
    const restartBtn = root.querySelector(`#zkx-restart-${sectionId}`);
    const errorEl = root.querySelector(`#zkx-error-${sectionId}`);

    const materialPriceEl = root.querySelector(`#zkx-material-price-${sectionId}`);
    const installPriceEl = root.querySelector(`#zkx-install-price-${sectionId}`);
    const totalPriceEl = root.querySelector(`#zkx-total-price-${sectionId}`);
    const priceNoteEl = root.querySelector(`#zkx-price-note-${sectionId}`);
    const summaryEl = root.querySelector(`#zkx-summary-${sectionId}`);
    const mobilePriceEl = root.querySelector(`#zkx-mobile-price-${sectionId}`);

    const resultImageEl = root.querySelector(`#zkx-result-image-${sectionId}`);
    const resultPlaceholderEl = root.querySelector(`#zkx-result-placeholder-${sectionId}`);

    const configTitle = root.querySelector(`#zkx-config-title-${sectionId}`);
    const configText = root.querySelector(`#zkx-config-text-${sectionId}`);
    const heightLabel = root.querySelector(`#zkx-height-label-${sectionId}`);
    const widthLabel = root.querySelector(`#zkx-width-label-${sectionId}`);
    const installText = root.querySelector(`#zkx-install-text-${sectionId}`);
    const installHint = root.querySelector(`#zkx-install-hint-${sectionId}`);

    const step5Eyebrow = root.querySelector(`#zkx-step5-eyebrow-${sectionId}`);
    const step5Title = root.querySelector(`#zkx-step5-title-${sectionId}`);
    const step5Text = root.querySelector(`#zkx-step5-text-${sectionId}`);
    const doppelstabColorGrid = root.querySelector(`#zkx-doppelstab-color-grid-${sectionId}`);
    const gateTypeGrid = root.querySelector(`#zkx-gate-type-grid-${sectionId}`);

    const standardConfigWrap = root.querySelector(`#zkx-standard-config-${sectionId}`);
    const schmuckConfigWrap = root.querySelector(`#zkx-schmuck-config-${sectionId}`);
    const gateColorWrap = root.querySelector(`#zkx-gate-color-wrap-${sectionId}`);

    const seriesGrid = root.querySelector(`#zkx-series-grid-${sectionId}`);
    const modelGrid = root.querySelector(`#zkx-model-grid-${sectionId}`);
    const extraGateGrid = root.querySelector(`#zkx-extra-gate-grid-${sectionId}`);
const extraGateConfig = root.querySelector(`#zkx-extra-gate-config-${sectionId}`);
const extraGateOptionsWrap = root.querySelector(`#zkx-extra-gate-options-${sectionId}`);
const extraGatePriceEl = root.querySelector(`#zkx-extra-gate-price-${sectionId}`);
const cornerPostsWrap = root.querySelector(`#zkx-corner-posts-wrap-${sectionId}`);
const cornerPostsInput = root.querySelector(`#zkx-corner-posts-${sectionId}`);

    const heightInput = root.querySelector(`#zkx-height-${sectionId}`);
    let widthInput = root.querySelector(`#zkx-width-${sectionId}`);
    const gateColorInput = root.querySelector(`#zkx-gate-color-${sectionId}`);
    const zipInput = root.querySelector(`#zkx-zip-${sectionId}`);

    const schmuckWidthInput = root.querySelector(`#zkx-schmuck-width-${sectionId}`);
    const schmuckHeightInput = root.querySelector(`#zkx-schmuck-height-${sectionId}`);
    const schmuckColorInput = root.querySelector(`#zkx-schmuck-color-${sectionId}`);
    const schmuckPforteInput = root.querySelector(`#zkx-schmuck-pforte-${sectionId}`);
    const schmuckDoppeltorInput = root.querySelector(`#zkx-schmuck-doppeltor-${sectionId}`);
    const schmuckSchiebetorInput = root.querySelector(`#zkx-schmuck-schiebetor-${sectionId}`);
    const schmuckBriefkastenInput = root.querySelector(`#zkx-schmuck-briefkasten-${sectionId}`);
    const schmuckMontageInput = root.querySelector(`#zkx-schmuck-montage-${sectionId}`);

    const firstnameInput = root.querySelector(`#zkx-firstname-${sectionId}`);
    const lastnameInput = root.querySelector(`#zkx-lastname-${sectionId}`);
    const emailInput = root.querySelector(`#zkx-email-${sectionId}`);
    const phoneInput = root.querySelector(`#zkx-phone-${sectionId}`);
    const messageInput = root.querySelector(`#zkx-message-${sectionId}`);

    const PREISE = window.ZAUN_PREISE || {};
    const SCHMUCK = window.ZAUN_SCHMUCKZAUN_DATEN || {};

    const INSTALL = {
      doppelstab_per_meter: 55,
      gate_manual: 1000,
      gate_electric: 1500
    };
    const CORNER_POST_PRODUCT_HANDLE = 'eckpfosten-zusatz';
const CORNER_POST_PRICES = {
  0: 0,
  1: 13.8,
  2: 27.6,
  3: 41.4,
  4: 55.2,
  5: 69.0
};
    const EXTRA_GATE_INSTALL_PRICES = {
  'gartentur-light': 250,
  'einflugeliges-tor-premium': 250,
  'multitor-premium-2-flugelig-fullung-8-6-8-mm': 600
};

function getExtraGateInstallPrice(handle = state?.extraGateHandle) {
  return EXTRA_GATE_INSTALL_PRICES[handle] || 0;
}

const EXTRA_GATE_PRODUCTS = {
  'gartentur-light': {
    title: 'Gartentür Light'
  },

  'einflugeliges-tor-premium': {
    title: 'Einflügeliges Tor Premium'
  },

  'multitor-premium-2-flugelig-fullung-8-6-8-mm': {
    title: 'Multitor Premium 2-flügelig'
  }
};

    const KOMPLETTSET_WIDTHS = [
      10.0, 12.5, 15.0, 17.5, 20.0, 22.5, 25.0, 27.5, 30.0,
      32.5, 35.0, 37.5, 40.0, 42.5, 45.0, 47.5, 50.0
    ];

    const SHOPIFY_PRODUCT_HANDLES = {
      doppelstab: {
        einzelmatten: {
          '656': 'doppelstab-einzelmatte-656',
          '868': 'doppelstab-einzelmatte-868'
        },
        komplettset: {
          '656': {
            light: 'doppelstab-komplettset-656-light',
            premium: 'doppelstab-komplettset-656-premium'
          },
          '868': {
            light: 'doppelstab-komplettset-868-light',
            premium: 'doppelstab-komplettset-868-premium'
          }
        }
      },
      schiebetor: {
        manual: 'schiebetor-handbetrieb',
        electric: 'schiebetor-elektrisch',
        industry9: 'industrie-schiebetor-bis-9m',
        industry16: 'industrie-schiebetor-bis-16m'
      },
      schmuckzaun: {
        'classic-aw-10-01': 'schmuckzaun-classic-aw-10-01',
        'classic-aw-10-02': 'schmuckzaun-classic-aw-10-02',
        'classic-aw-10-04': 'schmuckzaun-classic-aw-10-04',
        'classic-aw-10-05': 'schmuckzaun-classic-aw-10-05',
        'classic-aw-10-06': 'schmuckzaun-classic-aw-10-06',
        'classic-aw-10-16': 'schmuckzaun-classic-aw-10-16',
        'classic-aw-10-17': 'schmuckzaun-classic-aw-10-17',
        'classic-aw-10-70': 'schmuckzaun-classic-aw-10-70',
        'classic-aw-10-72': 'schmuckzaun-classic-aw-10-72',
        'classic-aw-10-76': 'schmuckzaun-classic-aw-10-76',
        'classic-aw-10-tt': 'schmuckzaun-classic-aw-10-tt',

        'home-01': 'schmuckzaun-home-01',
        'home-02': 'schmuckzaun-home-02',
        'home-03': 'schmuckzaun-home-03',
        'home-04': 'schmuckzaun-home-04',

        'lux-01': 'schmuckzaun-lux-01',
        'lux-02': 'schmuckzaun-lux-02',
        'lux-03': 'schmuckzaun-lux-03',
        'lux-04': 'schmuckzaun-lux-04',
        'lux-05': 'schmuckzaun-lux-05',
        'lux-06': 'schmuckzaun-lux-06',
        'lux-07': 'schmuckzaun-lux-07',
        'lux-08': 'schmuckzaun-lux-08',
        'lux-09': 'schmuckzaun-lux-09',
        'lux-10': 'schmuckzaun-lux-10',
        'lux-11': 'schmuckzaun-lux-11',
        'lux-12': 'schmuckzaun-lux-12',
        'lux-13': 'schmuckzaun-lux-13',
        'lux-14': 'schmuckzaun-lux-14',

        'modern-aw-10-100': 'schmuckzaun-modern-aw-10-100',
        'modern-aw-10-101': 'schmuckzaun-modern-aw-10-101',
        'modern-aw-10-102': 'schmuckzaun-modern-aw-10-102',
        'modern-aw-10-103': 'schmuckzaun-modern-aw-10-103',
        'modern-aw-10-104': 'schmuckzaun-modern-aw-10-104',
        'modern-aw-10-105': 'schmuckzaun-modern-aw-10-105',
        'modern-aw-10-106': 'schmuckzaun-modern-aw-10-106',
        'modern-aw-10-107': 'schmuckzaun-modern-aw-10-107',
        'modern-aw-10-108': 'schmuckzaun-modern-aw-10-108',
        'modern-aw-10-109': 'schmuckzaun-modern-aw-10-109',
        'modern-aw-10-110': 'schmuckzaun-modern-aw-10-110',
        'modern-aw-10-111': 'schmuckzaun-modern-aw-10-111',
        'modern-aw-10-112': 'schmuckzaun-modern-aw-10-112',
        'modern-aw-10-114': 'schmuckzaun-modern-aw-10-114',
        'modern-aw-10-115': 'schmuckzaun-modern-aw-10-115',

        'style-01': 'schmuckzaun-style-01',
        'style-02': 'schmuckzaun-style-02',
        'style-03': 'schmuckzaun-style-03',
        'style-04': 'schmuckzaun-style-04',
        'style-05': 'schmuckzaun-style-05',
        'style-06': 'schmuckzaun-style-06',

        'vario-01': 'schmuckzaun-vario-01',
        'vario-02': 'schmuckzaun-vario-02',
        'vario-03': 'schmuckzaun-vario-03',
        'vario-04': 'schmuckzaun-vario-04'
      }
    };

    const SCHMUCK_SERIES_PRODUCT_HANDLES = {
      classic: 'schmuckzaun-classic-aw-10-01',
      home: 'schmuckzaun-home-01',
      lux: 'schmuckzaun-lux-01',
      modern: 'schmuckzaun-modern-aw-10-101',
      style: 'schmuckzaun-style-01',
      vario: 'schmuckzaun-vario-01'
    };

    const SCHMUCK_MODEL_PRODUCT_HANDLES = {
      'classic-aw-10-01': 'schmuckzaun-classic-aw-10-01',
      'classic-aw-10-02': 'schmuckzaun-classic-aw-10-02',
      'classic-aw-10-04': 'schmuckzaun-classic-aw-10-04',
      'classic-aw-10-05': 'schmuckzaun-classic-aw-10-05',
      'classic-aw-10-06': 'schmuckzaun-classic-aw-10-06',
      'classic-aw-10-16': 'schmuckzaun-classic-aw-10-16',
      'classic-aw-10-17': 'schmuckzaun-classic-aw-10-17',
      'classic-aw-10-70': 'schmuckzaun-classic-aw-10-70',
      'classic-aw-10-72': 'schmuckzaun-classic-aw-10-72',
      'classic-aw-10-76': 'schmuckzaun-classic-aw-10-76',
      'classic-aw-10-tt': 'schmuckzaun-classic-aw-10-tt',

      'home-01': 'schmuckzaun-home-01',
      'home-02': 'schmuckzaun-home-02',
      'home-03': 'schmuckzaun-home-03',
      'home-04': 'schmuckzaun-home-04',

      'lux-01': 'schmuckzaun-lux-01',
      'lux-02': 'schmuckzaun-lux-02',
      'lux-03': 'schmuckzaun-lux-03',
      'lux-04': 'schmuckzaun-lux-04',
      'lux-05': 'schmuckzaun-lux-05',
      'lux-06': 'schmuckzaun-lux-06',
      'lux-07': 'schmuckzaun-lux-07',
      'lux-08': 'schmuckzaun-lux-08',
      'lux-09': 'schmuckzaun-lux-09',
      'lux-10': 'schmuckzaun-lux-10',
      'lux-11': 'schmuckzaun-lux-11',
      'lux-12': 'schmuckzaun-lux-12',
      'lux-13': 'schmuckzaun-lux-13',
      'lux-14': 'schmuckzaun-lux-14',

      'modern-aw-10-100': 'schmuckzaun-modern-aw-10-100',
      'modern-aw-10-101': 'schmuckzaun-modern-aw-10-101',
      'modern-aw-10-102': 'schmuckzaun-modern-aw-10-102',
      'modern-aw-10-103': 'schmuckzaun-modern-aw-10-103',
      'modern-aw-10-104': 'schmuckzaun-modern-aw-10-104',
      'modern-aw-10-105': 'schmuckzaun-modern-aw-10-105',
      'modern-aw-10-106': 'schmuckzaun-modern-aw-10-106',
      'modern-aw-10-107': 'schmuckzaun-modern-aw-10-107',
      'modern-aw-10-108': 'schmuckzaun-modern-aw-10-108',
      'modern-aw-10-109': 'schmuckzaun-modern-aw-10-109',
      'modern-aw-10-110': 'schmuckzaun-modern-aw-10-110',
      'modern-aw-10-111': 'schmuckzaun-modern-aw-10-111',
      'modern-aw-10-112': 'schmuckzaun-modern-aw-10-112',
      'modern-aw-10-114': 'schmuckzaun-modern-aw-10-114',
      'modern-aw-10-115': 'schmuckzaun-modern-aw-10-115',

      'style-01': 'schmuckzaun-style-01',
      'style-02': 'schmuckzaun-style-02',
      'style-03': 'schmuckzaun-style-03',
      'style-04': 'schmuckzaun-style-04',
      'style-05': 'schmuckzaun-style-05',
      'style-06': 'schmuckzaun-style-06',

      'vario-01': 'schmuckzaun-vario-01',
      'vario-02': 'schmuckzaun-vario-02',
      'vario-03': 'schmuckzaun-vario-03',
      'vario-04': 'schmuckzaun-vario-04'
    };

    const productCache = {};

    const state = {
      productType: '',
      doppelstabMode: '',
      doppelstabProfile: '',
      doppelstabPostVariant: '',
      doppelstabColor: '',
      gateType: '',
      gateVariant: '',
      gateColor: '',
      series: '',
      seriesTitle: '',
      model: '',
      modelId: '',
      modelImage: '',
      height: '',
      width: '',
      install: 'nein',
      zip: '',
      materialPrice: null,
      installPrice: 0,
      totalPrice: null,
      onRequest: false,
      cornerPosts: 0,
cornerPostsPrice: 0,
cornerPostVariantId: '',

      extraGateHandle: '',
extraGateTitle: '',
extraGateImage: '',
extraGateProduct: null,
extraGateOptions: {},
extraGateVariantId: '',
extraGateVariantTitle: '',
extraGateVariantPrice: 0,

      schmuckWidth: '',
      schmuckHeight: '',
      schmuckColor: '',
      schmuckPforte: '',
      schmuckDoppeltor: '',
      schmuckSchiebetor: '',
      schmuckBriefkasten: '',
      schmuckMontage: ''
    };

    let currentStep = 1;
    let seriesRenderToken = 0;
    let modelRenderToken = 0;

    function money(value) {
      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
      }).format(Number(value || 0));
    }

    function buildSafeImageUrl(src) {
      return src || '';
    }

    function normalizeWidthKey(value) {
      if (PREISE?.helpers?.normalizeWidthKey) {
        return PREISE.helpers.normalizeWidthKey(value);
      }

      const num = Number(String(value).replace(',', '.'));
      if (Number.isNaN(num)) return '';
      return num.toFixed(1);
    }

    function parseNum(value) {
      const num = Number(String(value || '').replace(',', '.'));
      return Number.isFinite(num) ? num : NaN;
    }

    function round2(value) {
      return Math.round((Number(value) + Number.EPSILON) * 100) / 100;
    }

    function clearError() {
      if (!errorEl) return;
      errorEl.hidden = true;
      errorEl.textContent = '';
    }

    function fail(message) {
      if (!errorEl) return false;
      errorEl.hidden = false;
      errorEl.textContent = message;
      return false;
    }

    function setHidden(el, hidden) {
      if (!el) return;
      el.hidden = hidden;
      el.style.display = hidden ? 'none' : '';
    }

    function setSelectOptions(select, options, placeholder = 'Bitte auswählen') {
      if (!select) return;

      const currentValue = select.value;
      select.innerHTML = '';

      const first = document.createElement('option');
      first.value = '';
      first.textContent = placeholder;
      select.appendChild(first);

      options.forEach((option) => {
        const opt = document.createElement('option');
        if (typeof option === 'object') {
          opt.value = option.value;
          opt.textContent = option.label;
        } else {
          opt.value = String(option);
          opt.textContent = String(option);
        }
        select.appendChild(opt);
      });

      if ([...select.options].some((opt) => opt.value === currentValue)) {
        select.value = currentValue;
      }
    }

    function bindPriceListeners(elements) {
      elements.filter(Boolean).forEach((el) => {
        el.addEventListener('input', updateMobilePrice);
        el.addEventListener('change', updateMobilePrice);
      });
    }

    function getVisibleSteps() {
  if (state.productType === 'doppelstab') {
    if (state.doppelstabMode === 'komplettset') {
      return [1, 2, 3, 4, 5, 8, 14, 9, 10, 11, 12, 13];
    }

    return [1, 2, 3, 5, 8, 9, 10, 11, 12, 13];
  }

  if (state.productType === 'schiebetor') {
    return [1, 5, 8, 9, 10, 11, 12, 13];
  }

  if (state.productType === 'schmuckzaun') {
    return [1, 6, 7, 8, 10, 11, 12, 13];
  }

  return [1];
}

    function updateSliderHeight() {
      if (!slider || !slides) return;

      const activeSlide = slides.querySelector(`.zkx__slide[data-step="${currentStep}"]`);
      if (!activeSlide) return;

      requestAnimationFrame(() => {
        const height = Math.ceil(activeSlide.offsetHeight);
        if (height > 0) {
          slider.style.height = `${height}px`;
        }
      });
    }

    function isRequestOnlyConfiguration() {
      if (state.productType === 'schmuckzaun') return true;
      if (state.install === 'ja') return true;
      if (state.productType === 'schiebetor' && state.gateType === 'industry16') return true;

      if (
        state.productType === 'doppelstab' &&
        state.doppelstabMode === 'komplettset' &&
        parseNum(state.width) > 50
      ) {
        return true;
      }

      return false;
    }

    function updateResultCtas() {
      const isRequestOnly = isRequestOnlyConfiguration();

      if (goOfferBtn) {
        goOfferBtn.textContent = isRequestOnly ? 'Kostenloses Angebot anfragen' : 'Jetzt in den Warenkorb';
      }

      if (mobileNextBtn) {
        if (currentStep === 11) {
          mobileNextBtn.textContent = isRequestOnly ? 'Angebot anfragen' : 'In den Warenkorb';
        } else if (currentStep === 12) {
          mobileNextBtn.textContent = 'Angebot anfordern';
        } else if (currentStep === 13) {
          mobileNextBtn.textContent = 'Neu starten';
        } else {
          mobileNextBtn.textContent = 'Weiter';
        }
      }
    }

    function updateMobileStickyVisibility() {
      if (!mobileSticky) return;

      const started = Boolean(state.productType);
      const hideOnSuccess = currentStep === 13;
      const shouldShow = started && !hideOnSuccess;

      mobileSticky.classList.toggle('is-visible', shouldShow);
    }
    function initStartCta() {
  if (root.querySelector('.zkx-start-cta')) return;

  const startTarget = root.querySelector('.zkx__slide[data-step="1"]');
  const insertTarget = progressLabel?.parentElement || root.querySelector('.zkx__intro, .zkx__head');

  if (!startTarget || !insertTarget) return;

  const cta = document.createElement('div');
  cta.className = 'zkx-start-cta';
  cta.innerHTML = `
    <button type="button" class="zkx-start-cta__button">
      Jetzt Zaun konfigurieren
    </button>
    <div class="zkx-start-cta__trust">
      <span>✓ Sofort kalkuliert</span>
      <span>✓ Standardzäune direkt bestellbar</span>
      <span>✓ Persönliche Fachberatung</span>
    </div>
  `;

  insertTarget.insertAdjacentElement('beforebegin', cta);

  cta.querySelector('button').addEventListener('click', () => {
    const top = startTarget.getBoundingClientRect().top + window.pageYOffset - 90;

    window.scrollTo({
      top: Math.max(0, top),
      behavior: 'smooth'
    });
  });
}

function updateStartCta() {
  const show = currentStep === 1 && !state.productType;

  root.classList.toggle('zkx--start', show);

  const cta = root.querySelector('.zkx-start-cta');
  if (cta) cta.hidden = !show;

  if (progressLabel) {
    progressLabel.style.display = show ? 'none' : '';
  }

  if (progressBar?.parentElement) {
    progressBar.parentElement.style.display = show ? 'none' : '';
  }
}

    function updateBackButtons() {
      const visible = getVisibleSteps();
      const idx = Math.max(0, visible.indexOf(currentStep));
      const showBack = idx > 0 && currentStep !== 13;

      if (backBtn) {
        backBtn.style.display = showBack ? 'inline-flex' : 'none';
      }

      if (mobileBackBtn) {
        mobileBackBtn.style.display = showBack ? 'inline-flex' : 'none';
      }
    }

    function updateNextButtons() {
      if (nextBtn) {
        nextBtn.style.display = [11, 12, 13].includes(currentStep) ? 'none' : 'inline-flex';
      }

      if (mobileNextBtn) {
        mobileNextBtn.style.display = currentStep === 13 ? 'inline-flex' : 'inline-flex';
      }
    }
function keepConfiguratorInView() {
  if (window.innerWidth > 749) return;

  const activeSlide = root.querySelector(`.zkx__slide[data-step="${currentStep}"]`);
  const target = activeSlide || root;

  window.setTimeout(() => {
    const top = target.getBoundingClientRect().top + window.pageYOffset - 110;

    window.scrollTo({
      top: Math.max(0, top),
      behavior: 'smooth'
    });
  }, 80);
}
    function showStep(step) {
      currentStep = step;
      window.clearTimeout(window.zkxExtraGateScrollTimer);


      

    if (slides) {
  const allSlides = [...slides.querySelectorAll('.zkx__slide')];

  const slideIndex = Math.max(
    0,
    allSlides.findIndex((slide) => Number(slide.dataset.step) === Number(step))
  );

  slides.style.transform = `translateX(-${slideIndex * 100}%)`;
}

      const visible = getVisibleSteps();
      const idx = Math.max(0, visible.indexOf(step));
      const progress = Math.max(0, Math.round(((idx + 1) / visible.length) * 100));

      if (progressBar) {
  progressBar.style.width = `${progress}%`;
  progressBar.style.background = '#22c55e';
}

console.log('PROGRESS', progress);

      if (progressLabel) {
        if (step === 11) progressLabel.textContent = 'Ergebnis';
        else if (step === 12) progressLabel.textContent = 'Anfrage';
        else if (step === 13) progressLabel.textContent = 'Bestätigung';
        else progressLabel.textContent = `Schritt ${idx + 1} von ${visible.length}`;
      }

      updateBackButtons();
      updateNextButtons();
      updateStep5Visibility();
      updateConfigVisibility();
      updateMobilePrice();
      updateResultCtas();
      updateMobileStickyVisibility();
      updateStartCta();
      clearError();

      setTimeout(updateSliderHeight, 20);
    }

    function nextStep() {
      clearError();
      if (!validateStep(currentStep)) return;

      if (currentStep === 10) {
        renderResult();
      }

      const visible = getVisibleSteps();
      const idx = visible.indexOf(currentStep);

      if (idx > -1 && idx < visible.length - 1) {
  showStep(visible[idx + 1]);
  keepConfiguratorInView();
}
    }

    function prevStep() {
      clearError();
      const visible = getVisibleSteps();
      const idx = visible.indexOf(currentStep);

      if (idx > 0) {
  showStep(visible[idx - 1]);
  keepConfiguratorInView();
}
    }

    function autoNext(delay = 120) {
      window.setTimeout(() => nextStep(), delay);
    }

    function select(group, btn) {
      root.querySelectorAll(group).forEach((el) => el.classList.remove('is-selected'));
      btn.classList.add('is-selected');
    }

    function updateStep5Visibility() {
      if (!step5Eyebrow || !step5Title || !step5Text || !doppelstabColorGrid || !gateTypeGrid) return;

      if (state.productType === 'doppelstab') {
        step5Eyebrow.textContent = state.doppelstabMode === 'komplettset' ? 'Schritt 5' : 'Schritt 4';
        step5Title.textContent = 'Farbton';
        step5Text.textContent = 'Wählen Sie den gewünschten Farbton.';
        setHidden(doppelstabColorGrid, false);
        setHidden(gateTypeGrid, true);
        return;
      }

      if (state.productType === 'schiebetor') {
        step5Eyebrow.textContent = 'Schritt 2';
        step5Title.textContent = 'Torsystem wählen';
        step5Text.textContent = 'Wählen Sie das passende Schiebetor.';
        setHidden(doppelstabColorGrid, true);
        setHidden(gateTypeGrid, false);
        return;
      }

      setHidden(doppelstabColorGrid, true);
      setHidden(gateTypeGrid, true);
    }

    function syncStateFromInputs() {
      state.height = heightInput ? heightInput.value : '';
      state.width = widthInput ? widthInput.value : '';
      state.gateColor = gateColorInput ? gateColorInput.value : '';
      state.zip = zipInput ? zipInput.value : '';
      state.cornerPosts = cornerPostsInput ? Number(cornerPostsInput.value || 0) : 0;
state.cornerPostsPrice = CORNER_POST_PRICES[state.cornerPosts] || 0;

      state.schmuckWidth = schmuckWidthInput ? schmuckWidthInput.value : '';
      state.schmuckHeight = schmuckHeightInput ? schmuckHeightInput.value : '';
      state.schmuckColor = schmuckColorInput ? schmuckColorInput.value : '';
      state.schmuckPforte = schmuckPforteInput ? schmuckPforteInput.value : '';
      state.schmuckDoppeltor = schmuckDoppeltorInput ? schmuckDoppeltorInput.value : '';
      state.schmuckSchiebetor = schmuckSchiebetorInput ? schmuckSchiebetorInput.value : '';
      state.schmuckBriefkasten = schmuckBriefkastenInput ? schmuckBriefkastenInput.value : '';
      state.schmuckMontage = schmuckMontageInput ? schmuckMontageInput.value : '';
    }

    function normalizeColorLabel(raw) {
      const value = String(raw || '').toLowerCase();

      if (value.includes('moos') || value.includes('grün') || value.includes('gruen')) {
        return 'Moosgrün RAL 6005';
      }
      if (value.includes('anthrazit')) {
        return 'Anthrazitgrau RAL 7016';
      }
      if (value.includes('schwarz')) {
        return 'Schwarz RAL 9005/Matt';
      }
      if (value.includes('feuerverzinkt')) {
        return 'Feuerverzinkt';
      }

      return '';
    }

    function normalizeExecutionLabel(raw) {
      const value = String(raw || '').toLowerCase();

      if (value.includes('antrieb') || value.includes('hohen schrank') || value.includes('hochschrank')) {
        return 'Mit Antrieb im hohen Schrank';
      }

      return 'Manuelle Öffnung';
    }

    function normalizeHeightLabel(raw) {
      const value = String(raw || '').trim();
      if (!value) return '';
      return `${value} mm`;
    }

    function normalizeWidthLabel(raw) {
      const key = normalizeWidthKey(raw || '');
      if (!key) return '';
      return `${key.replace('.', ',')} m`;
    }

    function resolveDoppelstabEinzelmattenColorKey(rawColor) {
      const value = String(rawColor || '').toLowerCase();

      if (
        value.includes('grün') ||
        value.includes('gruen') ||
        value.includes('moosgruen') ||
        value.includes('anthrazit')
      ) {
        return 'standard';
      }

      return '';
    }

    function resolveIndustry9VariantFromSelection() {
      const value = String(state.gateVariant || '').toLowerCase();
      if (value.includes('antrieb') || value.includes('hohen schrank') || value.includes('hochschrank')) {
        return 'antrieb_im_hohen_schrank';
      }
      return 'manual';
    }

    function getRoundedMatCount(widthValue) {
      const widthNum = parseNum(widthValue);
      if (!widthNum || widthNum <= 0) return 0;
      return Math.ceil(widthNum / 2.51);
    }

    async function fetchProductByHandle(handle) {
      if (!handle) return null;
      if (productCache[handle]) return productCache[handle];

      const response = await fetch(`/products/${handle}.js`, {
        credentials: 'same-origin'
      });

      if (!response.ok) {
        throw new Error(`Produkt konnte nicht geladen werden: ${handle}`);
      }

      const data = await response.json();
      productCache[handle] = data;
      return data;
    }

    function findVariantByOptions(product, expectedOptions) {
      if (!product || !Array.isArray(product.variants)) return null;

      return product.variants.find((variant) => {
        const variantOptions = [variant.option1, variant.option2, variant.option3].filter(Boolean);
        const wantedOptions = expectedOptions.filter(Boolean);

        if (variantOptions.length !== wantedOptions.length) return false;

        return wantedOptions.every((value, index) => {
          return String(variantOptions[index] || '').trim() === String(value || '').trim();
        });
      }) || null;
    }

    function getProductImageUrl(product, variant) {
      if (variant?.featured_image?.src) return variant.featured_image.src;
      if (product?.featured_image) return product.featured_image;
      if (Array.isArray(product?.images) && product.images.length > 0) return product.images[0];
      return '';
    }

    function getSchmuckHandleByModelId(modelId) {
      return SHOPIFY_PRODUCT_HANDLES.schmuckzaun[String(modelId || '').toLowerCase()] || '';
    }

    async function getSchmuckProductImageByModelId(modelId) {
      const handle = getSchmuckHandleByModelId(modelId);
      if (!handle) return '';

      try {
        const product = await fetchProductByHandle(handle);
        return getProductImageUrl(product, null) || '';
      } catch (error) {
        return '';
      }
    }

    async function getSchmuckSeriesImage(seriesKey, fallbackSrc = '') {
      const handle = SCHMUCK_SERIES_PRODUCT_HANDLES[seriesKey];
      if (!handle) return fallbackSrc || '';

      try {
        const product = await fetchProductByHandle(handle);
        return getProductImageUrl(product, null) || fallbackSrc || '';
      } catch (error) {
        return fallbackSrc || '';
      }
    }

    async function getSchmuckModelImage(modelId, fallbackSrc = '') {
      const handle = SCHMUCK_MODEL_PRODUCT_HANDLES[modelId];
      if (!handle) return fallbackSrc || '';

      try {
        const product = await fetchProductByHandle(handle);
        return getProductImageUrl(product, null) || fallbackSrc || '';
      } catch (error) {
        return fallbackSrc || '';
      }
    }

    async function renderSeriesCards() {
      if (!seriesGrid || !SCHMUCK.reihen) return;

      const myToken = ++seriesRenderToken;
      seriesGrid.innerHTML = '';

      const entries = Object.entries(SCHMUCK.reihen);
      const images = await Promise.all(
        entries.map(([seriesKey, reihe]) => getSchmuckSeriesImage(seriesKey, reihe.image || ''))
      );

      if (myToken !== seriesRenderToken) return;

      const fragment = document.createDocumentFragment();

      entries.forEach(([seriesKey, reihe], index) => {
        const imageSrc = buildSafeImageUrl(images[index] || reihe.image || '');

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'zkx-card zkx-card--series';
        btn.dataset.series = seriesKey;

        btn.innerHTML = imageSrc
          ? `
            <span class="zkx-card__media">
              <img src="${imageSrc}" alt="${reihe.title}" loading="eager" decoding="async">
            </span>
            <span class="zkx-card__title">${reihe.title}</span>
          `
          : `
            <span class="zkx-card__media">
              <span class="zkx-card__placeholder">${reihe.title}</span>
            </span>
            <span class="zkx-card__title">${reihe.title}</span>
          `;

        btn.addEventListener('click', () => {
          select('[data-series]', btn);
          state.series = seriesKey;
          state.seriesTitle = reihe.title || seriesKey;
          state.model = '';
          state.modelId = '';
          state.modelImage = '';
          renderModelCards();
          autoNext();
        });

        fragment.appendChild(btn);
      });

      seriesGrid.innerHTML = '';
      seriesGrid.appendChild(fragment);
      setTimeout(updateSliderHeight, 20);
    }

    async function renderModelCards() {
      if (!modelGrid || !SCHMUCK.reihen || !state.series) return;

      const myToken = ++modelRenderToken;
      const activeSeries = state.series;
      modelGrid.innerHTML = '';

      const reihe = SCHMUCK.reihen[activeSeries];
      if (!reihe || !Array.isArray(reihe.modelle)) return;

      const images = await Promise.all(
        reihe.modelle.map((modell) => getSchmuckModelImage(modell.id, modell.image || ''))
      );

      if (myToken !== modelRenderToken) return;
      if (activeSeries !== state.series) return;

      const fragment = document.createDocumentFragment();

      reihe.modelle.forEach((modell, index) => {
        const productImage = images[index] || '';
        const imageSrc = buildSafeImageUrl(productImage || modell.image || '');

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'zkx-card zkx-card--series';
        btn.dataset.model = modell.id;

        btn.innerHTML = imageSrc
          ? `
            <span class="zkx-card__media">
              <img src="${imageSrc}" alt="${modell.title}" loading="eager" decoding="async">
            </span>
            <span class="zkx-card__title">${modell.title}</span>
          `
          : `
            <span class="zkx-card__media">
              <span class="zkx-card__placeholder">${modell.title}</span>
            </span>
            <span class="zkx-card__title">${modell.title}</span>
          `;

        btn.addEventListener('click', () => {
          select('[data-model]', btn);
          state.model = modell.title;
          state.modelId = modell.id;
          state.modelImage = productImage || modell.image || '';
          autoNext();
        });

        fragment.appendChild(btn);
      });

      modelGrid.innerHTML = '';
      modelGrid.appendChild(fragment);
      setTimeout(updateSliderHeight, 20);
    }

    function initSchmuckSelects() {
      setSelectOptions(schmuckColorInput, SCHMUCK.farben || []);
      setSelectOptions(schmuckPforteInput, SCHMUCK.eingangspforte || []);
      setSelectOptions(schmuckDoppeltorInput, SCHMUCK.doppelfluegeltor || []);
      setSelectOptions(schmuckSchiebetorInput, SCHMUCK.schiebetor || []);
      setSelectOptions(schmuckBriefkastenInput, SCHMUCK.briefkasten || []);
      setSelectOptions(schmuckMontageInput, SCHMUCK.montage || []);
    }

    function ensureWidthField(isSelect) {
      const current = root.querySelector(`#zkx-width-${sectionId}`);
      if (!current) return null;

      if (isSelect && current.tagName === 'SELECT') return current;
      if (!isSelect && current.tagName === 'INPUT') return current;

      const currentValue = current.value || '';
      let replacement;

      if (isSelect) {
        replacement = document.createElement('select');
        replacement.id = `zkx-width-${sectionId}`;
        replacement.className = 'zkx__input';
      } else {
        replacement = document.createElement('input');
        replacement.id = `zkx-width-${sectionId}`;
        replacement.className = 'zkx__input';
        replacement.type = 'number';
        replacement.min = '1';
        replacement.step = '0.1';
        replacement.placeholder = 'z. B. 10,0';
      }

      replacement.value = currentValue;
      current.replaceWith(replacement);
      widthInput = replacement;
      bindPriceListeners([replacement]);

      return replacement;
    }

    function ensureIndustry9VariantField() {
      if (!standardConfigWrap) return;

      let wrap = root.querySelector(`#zkx-gate-variant-wrap-${sectionId}`);
      let selectEl = root.querySelector(`#zkx-gate-variant-${sectionId}`);

      if (!wrap) {
        wrap = document.createElement('div');
        wrap.className = 'zkx__field';
        wrap.id = `zkx-gate-variant-wrap-${sectionId}`;
        wrap.hidden = true;
        wrap.style.display = 'none';

        wrap.innerHTML = `
          <label for="zkx-gate-variant-${sectionId}">Ausführung</label>
          <select id="zkx-gate-variant-${sectionId}" class="zkx__input">
            <option value="">Bitte auswählen</option>
            <option value="manual">Manuelle Öffnung</option>
            <option value="antrieb_im_hohen_schrank">Mit Antrieb im hohen Schrank</option>
          </select>
        `;

        standardConfigWrap.appendChild(wrap);
        selectEl = wrap.querySelector('select');

        selectEl.addEventListener('change', () => {
          state.gateVariant = selectEl.value || '';
          updateMobilePrice();
        });
      }

      if (!selectEl) return;

      if (state.productType === 'schiebetor' && state.gateType === 'industry9') {
        setHidden(wrap, false);
      } else {
        setHidden(wrap, true);
        selectEl.value = '';
        state.gateVariant = '';
      }
    }

    function refreshIndustry9Widths() {
      if (!widthInput || !heightInput) return;
      if (state.gateType !== 'industry9') return;
      if (widthInput.tagName !== 'SELECT') return;

      const height = heightInput.value || state.height || '';
      let widths = ['6.0', '6.5', '7.0', '7.5', '8.0', '8.5', '9.0'];

      if (height === '1000') {
        widths = ['6.0', '6.5', '7.0', '7.5', '8.0'];
      }

      setSelectOptions(
        widthInput,
        widths.map((v) => ({ value: v, label: `${v.replace('.', ',')} m` }))
      );
    }

    function setupGateDropdowns() {
      if (!heightInput) return;

      ensureIndustry9VariantField();

      if (state.productType === 'doppelstab') {
        setSelectOptions(heightInput, [
          { value: '630', label: '630 mm' },
          { value: '830', label: '830 mm' },
          { value: '1030', label: '1030 mm' },
          { value: '1230', label: '1230 mm' },
          { value: '1430', label: '1430 mm' },
          { value: '1630', label: '1630 mm' },
          { value: '1830', label: '1830 mm' },
          { value: '2030', label: '2030 mm' }
        ]);

        if (state.doppelstabMode === 'komplettset') {
          ensureWidthField(true);
          const widthSelect = root.querySelector(`#zkx-width-${sectionId}`);
          if (widthSelect && widthSelect.tagName === 'SELECT') {
            widthInput = widthSelect;
            setSelectOptions(
              widthSelect,
              KOMPLETTSET_WIDTHS.map((v) => ({
                value: v.toFixed(1),
                label: `${v.toFixed(1).replace('.', ',')} m`
              }))
            );
          }
        } else {
          ensureWidthField(false);
        }
        return;
      }

      if (state.productType !== 'schiebetor') return;

      ensureWidthField(true);
      const widthSelect = root.querySelector(`#zkx-width-${sectionId}`);
      if (!widthSelect || widthSelect.tagName !== 'SELECT') return;
      widthInput = widthSelect;

      if (state.gateType === 'manual' || state.gateType === 'electric') {
        setSelectOptions(heightInput, [
          '830', '1030', '1230', '1430', '1630', '1830', '2030'
        ].map((v) => ({ value: v, label: `${v} mm` })));

        setSelectOptions(widthSelect, [
          '3.0', '3.5', '4.0', '4.5', '5.0', '5.5', '6.0'
        ].map((v) => ({ value: v, label: `${v.replace('.', ',')} m` })));
        return;
      }

      if (state.gateType === 'industry9') {
        setSelectOptions(heightInput, [
          '1000', '1200', '1400', '1600', '1800', '2000'
        ].map((v) => ({ value: v, label: `${v} mm` })));
        refreshIndustry9Widths();
        return;
      }

      if (state.gateType === 'industry16') {
        setSelectOptions(heightInput, [
          '1000', '1200', '1400', '1600', '1800', '2000'
        ].map((v) => ({ value: v, label: `${v} mm` })));

        const widthOptions = [];
        for (let w = 9.0; w <= 16.0; w += 0.5) {
          widthOptions.push({
            value: w.toFixed(1),
            label: `${w.toFixed(1).replace('.', ',')} m`
          });
        }
        setSelectOptions(widthSelect, widthOptions);
      }
    }

    function updateConfigVisibility() {
      if (!configTitle || !configText || !heightLabel || !widthLabel) return;

      if (state.productType === 'schmuckzaun') {
        setHidden(standardConfigWrap, true);
        setHidden(schmuckConfigWrap, false);
        if (gateColorWrap) setHidden(gateColorWrap, true);
        if (cornerPostsWrap) setHidden(cornerPostsWrap, true);
        configTitle.textContent = 'Schmuckzaun konfigurieren';
        configText.textContent = 'Bitte wählen Sie die gewünschten Optionen.';
        return;
      }

      setHidden(standardConfigWrap, false);
      setHidden(schmuckConfigWrap, true);

      if (state.productType === 'doppelstab') {
        configTitle.textContent = 'Doppelstabmatten konfigurieren';
        configText.textContent = state.doppelstabMode === 'komplettset'
          ? 'Bitte Höhe und Breite für Ihr Komplettset angeben.'
          : 'Bitte Höhe und laufende Meter angeben.';
        heightLabel.textContent = 'Höhe';
        widthLabel.textContent = state.doppelstabMode === 'komplettset' ? 'Breite' : 'Laufende Meter';
        if (gateColorWrap) setHidden(gateColorWrap, true);
        if (cornerPostsWrap) {
  setHidden(cornerPostsWrap, state.doppelstabMode !== 'komplettset');
}
      }

      if (state.productType === 'schiebetor') {
        configTitle.textContent = 'Schiebetor konfigurieren';
        configText.textContent = 'Bitte Höhe, Breite und Farbe wählen.';
        heightLabel.textContent = 'Torhöhe';
        widthLabel.textContent = 'Torbreite';
        if (gateColorWrap) setHidden(gateColorWrap, false);
        if (cornerPostsWrap) setHidden(cornerPostsWrap, true);
      }

      if (installText) {
        installText.textContent = 'Auf Wunsch erhalten Sie zusätzlich ein Angebot für die fachgerechte Montage.';
      }

      if (installHint) {
        installHint.textContent = 'Die finalen Montagekosten hängen von Produkt, Umfang und Einbauort ab und werden persönlich geprüft.';
      }

      setupGateDropdowns();
    }

    function getPriceFromLookup() {
      if (state.productType === 'schmuckzaun') {
        return { onRequest: true, value: null };
      }

      if (state.productType === 'schiebetor') {
        if (state.gateType === 'industry16') {
          return { onRequest: true, value: null };
        }

        const height = state.height || '';
        const width = normalizeWidthKey(state.width || '');

        if (!height || !width) {
          return { onRequest: false, value: null };
        }

        if (state.gateType === 'manual') {
          const value = PREISE?.schiebetor?.manual?.[height]?.[width];
          return { onRequest: false, value: value ?? null };
        }

        if (state.gateType === 'electric') {
          const value = PREISE?.schiebetor?.electric?.[height]?.[width];
          return { onRequest: false, value: value ?? null };
        }

        if (state.gateType === 'industry9') {
          const variant = resolveIndustry9VariantFromSelection();
          state.gateVariant = variant;
          const value = PREISE?.schiebetor?.industry9?.[variant]?.[height]?.[width];
          return { onRequest: false, value: value ?? null };
        }
      }

      if (state.productType === 'doppelstab') {
        const mode = state.doppelstabMode || '';
        const profile = state.doppelstabProfile || '';
        const color = state.doppelstabColor || '';
        const height = state.height || '';
        const widthNum = parseNum(state.width);
        const widthKeyValue = normalizeWidthKey(state.width || '');

        if (!mode || !profile || !height) {
          return { onRequest: false, value: null };
        }

        if (mode === 'einzelmatten') {
          if (!color || !Number.isFinite(widthNum) || widthNum <= 0) {
            return { onRequest: false, value: null };
          }

          const colorKey = resolveDoppelstabEinzelmattenColorKey(color);
          const unitPrice = PREISE?.doppelstab?.einzelmatten?.[profile]?.[colorKey]?.[height];

          if (unitPrice == null) {
            return { onRequest: false, value: null };
          }

          const matCount = Math.ceil(widthNum / 2.51);
          const value = round2(matCount * Number(unitPrice));
          return { onRequest: false, value };
        }

        if (mode === 'komplettset') {
          if (!state.doppelstabPostVariant || !widthKeyValue) {
            return { onRequest: false, value: null };
          }

          const widthAsNum = parseNum(state.width);
          if (!Number.isFinite(widthAsNum) || widthAsNum > 50) {
            return { onRequest: true, value: null };
          }

          const value = PREISE?.doppelstab?.komplettset?.[profile]?.[state.doppelstabPostVariant]?.[height]?.[widthKeyValue];

          if (value == null) {
            return { onRequest: true, value: null };
          }

          return { onRequest: false, value };
        }
      }

      return { onRequest: false, value: null };
    }

    function getInstallPrice() {
      if (state.productType === 'doppelstab') {
        if (state.install !== 'ja') return 0;
        const widthNum = parseNum(state.width);
        if (!Number.isFinite(widthNum) || widthNum <= 0) return 0;
        return round2(widthNum * INSTALL.doppelstab_per_meter);
      }

      if (state.productType === 'schiebetor') {
        if (state.install !== 'ja') return 0;

        if (state.gateType === 'manual') return INSTALL.gate_manual;
        if (state.gateType === 'electric') return INSTALL.gate_electric;

        if (state.gateType === 'industry9') {
          const variant = resolveIndustry9VariantFromSelection();
          return variant === 'antrieb_im_hohen_schrank'
            ? INSTALL.gate_electric
            : INSTALL.gate_manual;
        }

        if (state.gateType === 'industry16') {
          return null;
        }
      }

      return 0;
    }

    function calculatePrices() {
      state.materialPrice = null;
      state.installPrice = 0;
      state.totalPrice = null;
      state.onRequest = false;

      const lookup = getPriceFromLookup();
      const installValue = getInstallPrice();

      state.onRequest = lookup.onRequest;

      if (installValue === null) {
        state.installPrice = null;
      } else {
        state.installPrice = Number(installValue || 0);
      }
      if (
  state.installPrice !== null &&
  state.install === 'ja' &&
  state.extraGateHandle &&
  state.extraGateVariantId
) {
  state.installPrice = round2(Number(state.installPrice || 0) + getExtraGateInstallPrice());
}

      if (lookup.value !== null && lookup.value !== undefined) {
        state.materialPrice = Number(lookup.value);
      }
      
      if (state.extraGateHandle && state.extraGateVariantPrice > 0 && state.materialPrice !== null) {
  state.materialPrice = round2(Number(state.materialPrice) + Number(state.extraGateVariantPrice));
}
if (
  state.productType === 'doppelstab' &&
  state.doppelstabMode === 'komplettset' &&
  state.cornerPostsPrice > 0 &&
  state.materialPrice !== null
) {
  state.materialPrice = round2(Number(state.materialPrice) + Number(state.cornerPostsPrice));
}

      if (state.onRequest) {
        state.totalPrice = null;
        return;
      }

      if (state.materialPrice !== null) {
        const installForTotal = state.installPrice === null ? 0 : Number(state.installPrice || 0);
        state.totalPrice = round2(Number(state.materialPrice) + installForTotal);
      }
    }

    function updateMobilePrice() {
      syncStateFromInputs();
      calculatePrices();

      if (!mobilePriceEl) return;

      if (currentStep === 1 && !state.productType) {
        mobilePriceEl.textContent = 'Richtpreis';
        return;
      }

      if (state.onRequest) {
        mobilePriceEl.textContent = 'Preis auf Anfrage';
        return;
      }

      if (state.totalPrice !== null) {
        mobilePriceEl.textContent = money(state.totalPrice);
        return;
      }

      if (state.install === 'ja' && state.installPrice !== null && state.installPrice > 0) {
        mobilePriceEl.textContent = money(state.installPrice);
        return;
      }

      mobilePriceEl.textContent = 'Richtpreis';
    }

    async function getResultImageData() {
      if (state.productType === 'schmuckzaun' && state.modelId) {
        const shopifyImage = await getSchmuckProductImageByModelId(state.modelId);

        if (shopifyImage) {
          return {
            src: shopifyImage,
            alt: state.model || 'Schmuckzaun'
          };
        }

        if (state.modelImage) {
          return {
            src: state.modelImage,
            alt: state.model || 'Schmuckzaun'
          };
        }
      }

      try {
        if (state.productType === 'doppelstab') {
          if (state.doppelstabMode === 'einzelmatten') {
            const handle = SHOPIFY_PRODUCT_HANDLES.doppelstab.einzelmatten[state.doppelstabProfile || ''];
            const product = await fetchProductByHandle(handle);
            const colorLabel = normalizeColorLabel(state.doppelstabColor);
            const heightLabel = normalizeHeightLabel(state.height);
            const variant = findVariantByOptions(product, [colorLabel, heightLabel]);

            return {
              src: getProductImageUrl(product, variant),
              alt: `Doppelstabmatte ${state.doppelstabProfile}`
            };
          }

          if (state.doppelstabMode === 'komplettset') {
            const handle = SHOPIFY_PRODUCT_HANDLES.doppelstab.komplettset[state.doppelstabProfile || '']?.[state.doppelstabPostVariant || ''];
            const product = await fetchProductByHandle(handle);
            const colorLabel = normalizeColorLabel(state.doppelstabColor);
            const heightLabel = normalizeHeightLabel(state.height);
            const widthLabel = normalizeWidthLabel(state.width);
            const variant = findVariantByOptions(product, [colorLabel, heightLabel, widthLabel]);

            return {
              src: getProductImageUrl(product, variant),
              alt: `Doppelstab Komplettset ${state.doppelstabProfile}`
            };
          }
        }

        if (state.productType === 'schiebetor') {
          if (state.gateType === 'manual' || state.gateType === 'electric') {
            const handle = state.gateType === 'manual'
              ? SHOPIFY_PRODUCT_HANDLES.schiebetor.manual
              : SHOPIFY_PRODUCT_HANDLES.schiebetor.electric;

            const product = await fetchProductByHandle(handle);
            const colorLabel = normalizeColorLabel(state.gateColor);
            const heightLabel = normalizeHeightLabel(state.height);
            const widthLabel = normalizeWidthLabel(state.width);

            let variant = findVariantByOptions(product, [colorLabel, heightLabel, widthLabel]);
            if (!variant) {
              variant = findVariantByOptions(product, [heightLabel, widthLabel]);
            }

            return {
              src: getProductImageUrl(product, variant),
              alt: state.gateType === 'manual' ? 'Schiebetor Handbetrieb' : 'Elektrisches Schiebetor'
            };
          }

          if (state.gateType === 'industry9') {
            const product = await fetchProductByHandle(SHOPIFY_PRODUCT_HANDLES.schiebetor.industry9);
            const executionLabel = normalizeExecutionLabel(state.gateVariant);
            const heightLabel = normalizeHeightLabel(state.height);
            const widthLabel = normalizeWidthLabel(state.width);
            const variant = findVariantByOptions(product, [executionLabel, heightLabel, widthLabel]);

            return {
              src: getProductImageUrl(product, variant),
              alt: 'Industrie Schiebetor bis 9 m'
            };
          }

          if (state.gateType === 'industry16') {
            const product = await fetchProductByHandle(SHOPIFY_PRODUCT_HANDLES.schiebetor.industry16);
            return {
              src: getProductImageUrl(product, null),
              alt: 'Industrie Schiebetor bis 16 m'
            };
          }
        }
      } catch (error) {}

      if (state.productType === 'doppelstab' && root.dataset.imageDoppelstab) {
        return {
          src: root.dataset.imageDoppelstab,
          alt: 'Doppelstabmatten'
        };
      }

      if (state.productType === 'schiebetor' && root.dataset.imageSchiebetor) {
        return {
          src: root.dataset.imageSchiebetor,
          alt: 'Schiebetor'
        };
      }

      if (root.dataset.imageFallback) {
        return {
          src: root.dataset.imageFallback,
          alt: 'Vorschaubild'
        };
      }

      return {
        src: '',
        alt: ''
      };
    }

    async function setResultImage() {
      if (!resultImageEl || !resultPlaceholderEl) return;

      const imageData = await getResultImageData();
      const src = imageData?.src || '';
      const alt = imageData?.alt || '';

      if (src) {
        resultImageEl.src = src;
        resultImageEl.alt = alt;
        resultImageEl.hidden = false;
        resultPlaceholderEl.hidden = true;
      } else {
        resultImageEl.hidden = true;
        resultPlaceholderEl.hidden = false;
      }
    }

    function renderResult() {
      calculatePrices();
      setResultImage();

      if (state.onRequest) {
        materialPriceEl.textContent = 'Preis auf Anfrage';

        if (state.productType === 'schmuckzaun') {
          installPriceEl.textContent =
            state.schmuckMontage && String(state.schmuckMontage).toLowerCase().includes('mit')
              ? 'Auf Anfrage'
              : 'Nicht ausgewiesen';
        } else {
          installPriceEl.textContent = state.install === 'ja'
            ? (state.installPrice === null ? 'Auf Anfrage' : money(state.installPrice))
            : money(0);
        }

        totalPriceEl.textContent = 'Preis auf Anfrage';
        priceNoteEl.textContent = 'Dieses Produkt wird individuell angeboten.';
      } else if (state.materialPrice !== null) {
        materialPriceEl.textContent = money(state.materialPrice);
        installPriceEl.textContent = state.installPrice === null ? 'Auf Anfrage' : money(state.installPrice || 0);
        totalPriceEl.textContent = money(state.totalPrice || 0);
        priceNoteEl.textContent = state.install === 'ja'
          ? 'Unverbindliche Orientierung inkl. hinterlegter Montagekosten.'
          : 'Unverbindliche Orientierung auf Basis der hinterlegten Werte.';
      } else {
        materialPriceEl.textContent = '–';

        if (state.productType === 'schmuckzaun') {
          installPriceEl.textContent =
            state.schmuckMontage && String(state.schmuckMontage).toLowerCase().includes('mit')
              ? 'Auf Anfrage'
              : 'Nicht ausgewiesen';
        } else {
          installPriceEl.textContent = state.install === 'ja' ? money(state.installPrice || 0) : money(0);
        }

        totalPriceEl.textContent = '–';
        priceNoteEl.textContent = 'Bitte vervollständigen Sie Ihre Angaben.';
      }

      const rows = [];

      if (state.productType === 'doppelstab') {
        rows.push(['Produktbereich', 'Doppelstabmatten']);
        rows.push(['Ausführung', state.doppelstabMode === 'komplettset' ? 'Komplettset' : 'Einzelmatten']);
        rows.push(['Drahtstärke', state.doppelstabProfile === '868' ? '8/6/8' : '6/5/6']);

        if (state.doppelstabMode === 'komplettset') {
          rows.push([
            'Pfostenvariante',
            state.doppelstabPostVariant === 'premium' ? 'Pfosten premium' : 'Pfosten light'
          ]);
        }

        rows.push([
          'Farbe',
          state.doppelstabColor === 'moosgruen'
            ? 'Moosgrün RAL 6005'
            : state.doppelstabColor === 'anthrazit'
              ? 'Anthrazitgrau RAL 7016'
              : '–'
        ]);

        rows.push(['Höhe', state.height ? `${state.height} mm` : '–']);
        rows.push(['Laufende Meter', state.width ? `${normalizeWidthKey(state.width).replace('.', ',')} m` : '–']);
        if (state.doppelstabMode === 'komplettset') {
  rows.push([
    'Eckpfosten',
    state.cornerPosts > 0
      ? `${state.cornerPosts} Stk. (${money(state.cornerPostsPrice)})`
      : '0'
  ]);
}
        rows.push(['Montage', state.install === 'ja' ? 'Ja' : 'Nein']);
        if (state.doppelstabMode === 'komplettset') {
  rows.push(['Tor', state.extraGateHandle ? (state.extraGateTitle || 'Tor gewählt') : 'Ohne Tor']);

  if (state.extraGateHandle) {
    rows.push(['Tor-Variante', state.extraGateVariantTitle || '–']);
    rows.push(['Torpreis', state.extraGateVariantPrice ? money(state.extraGateVariantPrice) : '–']);
    rows.push([
  'Toreinbau',
  state.install === 'ja'
    ? money(getExtraGateInstallPrice())
    : 'Nicht gewählt'
]);
  }
}
      }

      if (state.productType === 'schiebetor') {
        const gateTypeTitleMap = {
          manual: 'Schiebetor Handbetrieb',
          electric: 'Elektrisches Schiebetor',
          industry9: 'Industrie Schiebetor bis 9 m',
          industry16: 'Industrie Schiebetor bis 16 m'
        };

        rows.push(['Produktbereich', 'Schiebetor']);
        rows.push(['Tortyp', gateTypeTitleMap[state.gateType] || '–']);

        if (state.gateType === 'industry9') {
          rows.push([
            'Ausführung',
            state.gateVariant === 'antrieb_im_hohen_schrank'
              ? 'Mit Antrieb im hohen Schrank'
              : 'Manuelle Öffnung'
          ]);
        }

        rows.push(['Farbe', state.gateColor || '–']);
        rows.push(['Höhe', state.height ? `${state.height} mm` : '–']);
        rows.push(['Breite', state.width ? `${normalizeWidthKey(state.width).replace('.', ',')} m` : '–']);
        rows.push(['Montage', state.install === 'ja' ? 'Ja' : 'Nein']);
      }

      if (state.productType === 'schmuckzaun') {
        rows.push(['Produktbereich', 'Schmuckzaun']);
        rows.push(['Modellreihe', state.seriesTitle || '–']);
        rows.push(['Modell', state.model || '–']);
        rows.push(['Gesamtbreite', state.schmuckWidth ? `${normalizeWidthKey(state.schmuckWidth).replace('.', ',')} m` : '–']);
        rows.push(['Zaunhöhe', state.schmuckHeight || '–']);
        rows.push(['Farbe', state.schmuckColor || '–']);
        rows.push(['Eingangspforte', state.schmuckPforte || '–']);
        rows.push(['Doppelflügeltor', state.schmuckDoppeltor || '–']);
        rows.push(['Premium-Schiebetor', state.schmuckSchiebetor || '–']);
        rows.push(['Briefkasten', state.schmuckBriefkasten || '–']);
        rows.push(['Montage', state.schmuckMontage || '–']);
      }

      rows.push(['PLZ', state.zip || '–']);

      summaryEl.innerHTML = rows
        .map(([label, value]) => `<li><span>${label}</span><strong>${value}</strong></li>`)
        .join('');

      updateMobilePrice();
      updateResultCtas();
      setTimeout(updateSliderHeight, 20);
    }

    function centsToEuro(value) {
  return Number(value || 0) / 100;
}

function getProductOptionNames(product) {
  if (!product || !Array.isArray(product.options)) return [];

  return product.options.map((option) => {
    if (typeof option === 'string') return option;
    return option?.name || '';
  }).filter(Boolean);
}

function getSelectedExtraGateVariant() {
  const product = state.extraGateProduct;

  if (!product || !Array.isArray(product.variants)) {
    return null;
  }

  const optionNames = getProductOptionNames(product);

  return product.variants.find((variant) => {
    return optionNames.every((optionName, index) => {
      const selected = state.extraGateOptions[optionName];

      const variantValue = [
        variant.option1,
        variant.option2,
        variant.option3
      ][index];

      return String(selected || '').trim() === String(variantValue || '').trim();
    });
  }) || null;
}

function updateExtraGateVariant() {
  const variant = getSelectedExtraGateVariant();

  if (!variant) {
    state.extraGateVariantId = '';
    state.extraGateVariantTitle = '';
    state.extraGateVariantPrice = 0;

    if (extraGatePriceEl && state.extraGateHandle) {
      extraGatePriceEl.textContent = 'Bitte wählen Sie alle Tor-Optionen.';
    }

    updateMobilePrice();
    return;
  }

  state.extraGateVariantId = String(variant.id || '');
  state.extraGateVariantTitle = variant.title || '';
  state.extraGateVariantPrice = centsToEuro(variant.price);

  if (extraGatePriceEl) {
    const installText =
  state.install === 'ja'
    ? ` + ${money(getExtraGateInstallPrice())} Toreinbau`
    : '';

    extraGatePriceEl.textContent =
      `Torpreis: ${money(state.extraGateVariantPrice)}${installText}`;
  }

  updateMobilePrice();
}

function renderExtraGateOptionSelects(product) {
  if (!extraGateOptionsWrap) return;

  extraGateOptionsWrap.innerHTML = '';

  const optionNames = getProductOptionNames(product);

  optionNames.forEach((optionName, optionIndex) => {

    const values = [
      ...new Set(
        product.variants
          .map((variant) => {
            return [
              variant.option1,
              variant.option2,
              variant.option3
            ][optionIndex];
          })
          .filter(Boolean)
      )
    ];

    const field = document.createElement('div');
    field.className = 'zkx__field';

    const label = document.createElement('label');
    label.textContent = optionName;

    const select = document.createElement('select');
    select.className = 'zkx__input';

    const placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = 'Bitte auswählen';

    select.appendChild(placeholder);

    values.forEach((value) => {
      const opt = document.createElement('option');
      opt.value = value;
      opt.textContent = value;
      select.appendChild(opt);
    });

    select.addEventListener('change', () => {
      state.extraGateOptions[optionName] = select.value || '';
      updateExtraGateVariant();
    });

    field.appendChild(label);
    field.appendChild(select);

    extraGateOptionsWrap.appendChild(field);
  });

  updateExtraGateVariant();
}
async function updateCornerPostVariant() {
  state.cornerPostVariantId = '';

  if (!state.cornerPosts || state.cornerPosts <= 0) return;

  try {
    const product = await fetchProductByHandle(CORNER_POST_PRODUCT_HANDLE);
    const wantedTitle = `${state.cornerPosts} Eckpfosten`;

    const variant = product.variants.find((v) => {
      return String(v.title || '').trim() === wantedTitle;
    });

    if (variant) {
      state.cornerPostVariantId = String(variant.id || '');
    }
  } catch (error) {}
}
async function selectExtraGate(handle, btn) {
  clearError();

  root.querySelectorAll('[data-extra-gate-handle]').forEach((el) => {
    el.classList.remove('is-selected');
  });

  btn.classList.add('is-selected');

  state.extraGateHandle = handle || '';
  state.extraGateTitle = '';
  state.extraGateImage = '';
  state.extraGateProduct = null;
  state.extraGateOptions = {};
  state.extraGateVariantId = '';
  state.extraGateVariantTitle = '';
  state.extraGateVariantPrice = 0;

  if (!handle) {
    setHidden(extraGateConfig, true);

    if (extraGateOptionsWrap) {
      extraGateOptionsWrap.innerHTML = '';
    }

    autoNext();
    return;
  }

  try {
    const product = await fetchProductByHandle(handle);

    state.extraGateProduct = product;
    state.extraGateTitle = product.title || handle;
    state.extraGateImage = getProductImageUrl(product, null) || '';

    setHidden(extraGateConfig, false);

renderExtraGateOptionSelects(product);

updateSliderHeight();
window.clearTimeout(window.zkxExtraGateScrollTimer);

window.zkxExtraGateScrollTimer = window.setTimeout(() => {
  if (!extraGateConfig || currentStep !== 14) return;

  const headerOffset = 120;
  const targetTop =
    extraGateConfig.getBoundingClientRect().top +
    window.pageYOffset -
    headerOffset;

  window.scrollTo({
    top: Math.max(0, targetTop),
    behavior: 'smooth'
  });
}, 250);

  } catch (error) {
    fail('Torprodukt konnte nicht geladen werden.');
  }
}

async function renderExtraGateCards() {
  if (!extraGateGrid) return;

  const cards = [
    ...extraGateGrid.querySelectorAll('[data-extra-gate-handle]')
  ];

  cards.forEach(async (btn) => {

    const handle = btn.dataset.extraGateHandle || '';

    if (!handle) return;

    try {
      const product = await fetchProductByHandle(handle);

      const image = getProductImageUrl(product, null);

      const media = btn.querySelector('.zkx-card__media');

      if (media && image) {
        media.innerHTML = `
          <img
            src="${image}"
            alt="${product.title}"
            loading="eager"
            decoding="async"
          >
        `;
      }

    } catch (error) {}
  });
}
    function validateStep(step) {
      syncStateFromInputs();

      if (step === 1 && !state.productType) return fail('Bitte wählen Sie zuerst einen Produktbereich.');
      if (step === 2 && state.productType === 'doppelstab' && !state.doppelstabMode) return fail('Bitte wählen Sie die Ausführung.');
      if (step === 3 && state.productType === 'doppelstab' && !state.doppelstabProfile) return fail('Bitte wählen Sie die Drahtstärke.');
      if (step === 4 && state.productType === 'doppelstab' && state.doppelstabMode === 'komplettset' && !state.doppelstabPostVariant) {
        return fail('Bitte wählen Sie die Pfostenvariante.');
      }

      if (step === 5) {
        if (state.productType === 'doppelstab' && !state.doppelstabColor) {
          return fail('Bitte wählen Sie die Farbe.');
        }
        if (state.productType === 'schiebetor' && !state.gateType) {
          return fail('Bitte wählen Sie ein Torsystem.');
        }
      }

      if (step === 6 && !state.series) return fail('Bitte wählen Sie eine Modellreihe.');
      if (step === 7 && !state.model) return fail('Bitte wählen Sie ein Modell.');
      
      if (step === 14) {

  if (!state.extraGateHandle) {
    return true;
  }

  if (!state.extraGateVariantId) {
    return fail('Bitte wählen Sie alle Tor-Optionen.');
  }
}

      if (step === 8) {
        if (state.productType === 'schmuckzaun') {
          if (!state.schmuckWidth || parseNum(state.schmuckWidth) <= 0) return fail('Bitte geben Sie die Gesamtbreite an.');
          if (!state.schmuckHeight) return fail('Bitte wählen Sie die Zaunhöhe.');
          if (!state.schmuckColor) return fail('Bitte wählen Sie die Farbe.');
          return true;
        }

        const widthNum = parseNum(state.width);

        if (!state.height) return fail('Bitte wählen Sie die Höhe.');
        if (!Number.isFinite(widthNum) || widthNum <= 0) return fail('Bitte wählen Sie die Breite.');

        if (state.productType === 'doppelstab' && state.doppelstabMode === 'komplettset' && widthNum > 50) {
          return fail('Komplettsets sind bis 50,0 m direkt kalkulierbar. Darüber erstellen wir Ihnen gern ein Angebot auf Anfrage.');
        }

        if (state.productType === 'schiebetor' && !state.gateColor) {
          return fail('Bitte wählen Sie die Farbe.');
        }

        if (state.productType === 'schiebetor' && state.gateType === 'industry9' && !state.gateVariant) {
          return fail('Bitte wählen Sie die Ausführung.');
        }
      }

      if (step === 9) {
        if (state.productType !== 'schmuckzaun' && !state.install) {
          return fail('Bitte wählen Sie, ob Montage gewünscht ist.');
        }
      }

      if (step === 10) {
        if (!/^[0-9]{5}$/.test(state.zip)) {
          return fail('Bitte geben Sie eine gültige 5-stellige PLZ ein.');
        }
      }

      if (step === 12) {
        if (!firstnameInput?.value.trim()) return fail('Bitte geben Sie Ihren Vornamen an.');
        if (!lastnameInput?.value.trim()) return fail('Bitte geben Sie Ihren Nachnamen an.');
        if (!emailInput?.value.trim()) return fail('Bitte geben Sie Ihre E-Mail-Adresse an.');
      }

      return true;
    }

    function collectHubspotFields() {
      syncStateFromInputs();

      return [
        { name: 'firstname', value: firstnameInput?.value || '' },
        { name: 'lastname', value: lastnameInput?.value || '' },
        { name: 'email', value: emailInput?.value || '' },
        { name: 'phone', value: phoneInput?.value || '' },
        { name: 'message', value: messageInput?.value || '' },
        { name: 'konfigurator_typ', value: state.productType || '' },
        { name: 'zip', value: state.zip || '' },
        { name: 'konfigurator_install', value: state.install || '' },
        { name: 'konfigurator_materialpreis', value: state.materialPrice !== null ? String(state.materialPrice) : '' },
        { name: 'konfigurator_montagepreis', value: state.installPrice !== null ? String(state.installPrice || 0) : '' },
        { name: 'konfigurator_gesamtpreis', value: state.totalPrice !== null ? String(state.totalPrice) : '' },
        { name: 'konfigurator_doppelstab_mode', value: state.doppelstabMode || '' },
        { name: 'konfigurator_doppelstab_profil', value: state.doppelstabProfile || '' },
        { name: 'konfigurator_doppelstab_pfostenvariante', value: state.doppelstabPostVariant || '' },
        { name: 'konfigurator_doppelstab_farbe', value: state.doppelstabColor || '' },
        { name: 'konfigurator_gate_type', value: state.gateType || '' },
        { name: 'konfigurator_gate_variant', value: state.gateVariant || '' },
        { name: 'konfigurator_gate_color', value: state.gateColor || '' },
        { name: 'konfigurator_reihe', value: state.seriesTitle || '' },
        { name: 'konfigurator_modell', value: state.model || '' },
        { name: 'konfigurator_schmuck_breite', value: state.schmuckWidth || '' },
        { name: 'konfigurator_schmuck_hoehe', value: state.schmuckHeight || '' },
        { name: 'konfigurator_schmuck_farbe', value: state.schmuckColor || '' },
        { name: 'konfigurator_schmuck_pforte', value: state.schmuckPforte || '' },
        { name: 'konfigurator_schmuck_doppeltor', value: state.schmuckDoppeltor || '' },
        { name: 'konfigurator_schmuck_schiebetor', value: state.schmuckSchiebetor || '' },
        { name: 'konfigurator_schmuck_briefkasten', value: state.schmuckBriefkasten || '' },
        { name: 'konfigurator_schmuck_montage', value: state.schmuckMontage || '' },
        { name: 'konfigurator_hoehe', value: state.height || '' },
        { name: 'konfigurator_breite', value: state.width || '' },
        { name: 'konfigurator_eckpfosten_anzahl', value: String(state.cornerPosts || 0) },
{ name: 'konfigurator_eckpfosten_preis', value: state.cornerPostsPrice ? String(state.cornerPostsPrice) : '' },
{ name: 'konfigurator_extra_tor', value: state.extraGateTitle || '' },
{ name: 'konfigurator_extra_tor_handle', value: state.extraGateHandle || '' },
{ name: 'konfigurator_extra_tor_variante', value: state.extraGateVariantTitle || '' },
{ name: 'konfigurator_extra_tor_preis', value: state.extraGateVariantPrice ? String(state.extraGateVariantPrice) : '' },
{
  name: 'konfigurator_extra_tor_montagepreis',
  value:
    state.install === 'ja' && state.extraGateHandle
      ? String(getExtraGateInstallPrice())
      : ''
},
{ name: 'konfigurator_preis_auf_anfrage', value: state.onRequest ? 'ja' : 'nein' }
      ];
    }

    async function submit() {
      clearError();
      if (!validateStep(12)) return;

      const portalId = root.dataset.hubspotPortalId;
      const formId = root.dataset.hubspotFormId;
      const fields = collectHubspotFields();

      if (!portalId || !formId) {
        console.log('HubSpot Demo Payload', fields);
        showStep(13);
        return;
      }

      submitBtn.disabled = true;
      submitBtn.textContent = 'Wird gesendet ...';

      try {
        const url = `https://api.hsforms.com/submissions/v3/integration/submit/${encodeURIComponent(portalId)}/${encodeURIComponent(formId)}`;
        const payload = {
          fields,
          context: {
            pageUri: window.location.href,
            pageName: document.title
          }
        };

        const response = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });

        if (!response.ok) throw new Error('HubSpot Submit fehlgeschlagen');

if (typeof gtag === 'function') {
  gtag('event', 'generate_lead', {
    value: state.totalPrice || 0,
    currency: 'EUR',
    lead_type: 'zaun_konfigurator',
    konfigurator_typ: state.productType || '',
    montage: state.install || '',
    plz: state.zip || '',
    materialpreis: state.materialPrice || 0,
    montagepreis: state.installPrice || 0
  });
}

showStep(13);
      } catch (error) {
        fail('Die Anfrage konnte aktuell nicht gesendet werden. Bitte prüfen Sie später die HubSpot-Konfiguration.');
      } finally {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Unverbindliches Angebot anfordern';
      }
    }

    async function resolveCartTarget() {
      syncStateFromInputs();

      if (state.productType === 'schmuckzaun') {
        return {
          mode: 'request',
          reason: 'Schmuckzäune sind Anfrageprodukte.'
        };
      }

      if (state.install === 'ja') {
        return {
          mode: 'request',
          reason: 'Produkte mit Montage laufen über die Anfrage.'
        };
      }

      if (state.productType === 'schiebetor' && state.gateType === 'industry16') {
        return {
          mode: 'request',
          reason: 'Industrie Schiebetor bis 16 m ist Anfrageprodukt.'
        };
      }

      if (state.productType === 'doppelstab') {
        const widthNum = parseNum(state.width);

        if (state.doppelstabMode === 'komplettset' && widthNum > 50) {
          return {
            mode: 'request',
            reason: 'Längen über 50 m laufen über die Anfrage.'
          };
        }

        if (state.doppelstabMode === 'einzelmatten') {
          const handle = SHOPIFY_PRODUCT_HANDLES.doppelstab.einzelmatten[state.doppelstabProfile || ''];
          const product = await fetchProductByHandle(handle);

          const colorLabel = normalizeColorLabel(state.doppelstabColor);
          const heightLabel = normalizeHeightLabel(state.height);
          const variant = findVariantByOptions(product, [colorLabel, heightLabel]);

          if (!variant) {
            throw new Error(`Keine passende Variante gefunden für ${handle}: ${colorLabel} / ${heightLabel}`);
          }

          const matCount = getRoundedMatCount(state.width);
          if (!matCount) {
            throw new Error('Keine gültige Mattenanzahl berechnet.');
          }

          return {
            mode: 'cart',
            items: [
              {
                id: variant.id,
                quantity: matCount,
                properties: {
                  'Laufende Meter': normalizeWidthLabel(state.width)
                }
              }
            ]
          };
        }

        if (state.doppelstabMode === 'komplettset') {
          const variantKey = state.doppelstabPostVariant || '';
          const handle = SHOPIFY_PRODUCT_HANDLES.doppelstab.komplettset[state.doppelstabProfile || '']?.[variantKey];
          const product = await fetchProductByHandle(handle);

          const colorLabel = normalizeColorLabel(state.doppelstabColor);
          const heightLabel = normalizeHeightLabel(state.height);
          const widthLabel = normalizeWidthLabel(state.width);

          const variant = findVariantByOptions(product, [colorLabel, heightLabel, widthLabel]);

          if (!variant) {
            throw new Error(`Keine passende Variante gefunden für ${handle}: ${colorLabel} / ${heightLabel} / ${widthLabel}`);
          }

          const items = [
  {
    id: variant.id,
    quantity: 1
  }
];
if (state.cornerPosts > 0) {
  await updateCornerPostVariant();

  if (state.cornerPostVariantId) {
    items.push({
      id: Number(state.cornerPostVariantId),
      quantity: 1,
      properties: {
        'Zusatzprodukt': 'Eckpfosten zum Doppelstab-Komplettset',
        'Anzahl': `${state.cornerPosts} Eckpfosten`
      }
    });
  }
}

if (state.extraGateHandle && state.extraGateVariantId) {
  items.push({
    id: Number(state.extraGateVariantId),
    quantity: 1,
    properties: {
      'Zusatzprodukt': 'Tor zum Doppelstab-Komplettset',
      'Tor': state.extraGateTitle || '',
      'Tor-Variante': state.extraGateVariantTitle || ''
    }
  });
}

return {
  mode: 'cart',
  items
};
        }
      }

      if (state.productType === 'schiebetor') {
        if (state.gateType === 'manual' || state.gateType === 'electric') {
          const handle = state.gateType === 'manual'
            ? SHOPIFY_PRODUCT_HANDLES.schiebetor.manual
            : SHOPIFY_PRODUCT_HANDLES.schiebetor.electric;

          const product = await fetchProductByHandle(handle);

          const colorLabel = normalizeColorLabel(state.gateColor);
          const heightLabel = normalizeHeightLabel(state.height);
          const widthLabel = normalizeWidthLabel(state.width);

          let variant = findVariantByOptions(product, [colorLabel, heightLabel, widthLabel]);

          if (!variant) {
            variant = findVariantByOptions(product, [heightLabel, widthLabel]);
          }

          if (!variant) {
            throw new Error(`Keine passende Variante gefunden für ${handle}: ${colorLabel} / ${heightLabel} / ${widthLabel}`);
          }

          const properties = {};
          if (variant.option1 !== colorLabel && colorLabel) {
            properties['Farbe'] = colorLabel;
          }

          return {
            mode: 'cart',
            items: [
              {
                id: variant.id,
                quantity: 1,
                properties
              }
            ]
          };
        }

        if (state.gateType === 'industry9') {
          const handle = SHOPIFY_PRODUCT_HANDLES.schiebetor.industry9;
          const product = await fetchProductByHandle(handle);

          const executionLabel = normalizeExecutionLabel(state.gateVariant);
          const heightLabel = normalizeHeightLabel(state.height);
          const widthLabel = normalizeWidthLabel(state.width);
          const variant = findVariantByOptions(product, [executionLabel, heightLabel, widthLabel]);

          if (!variant) {
            throw new Error(`Keine passende Variante gefunden für ${handle}: ${executionLabel} / ${heightLabel} / ${widthLabel}`);
          }

          const colorLabel = normalizeColorLabel(state.gateColor);

          return {
            mode: 'cart',
            items: [
              {
                id: variant.id,
                quantity: 1,
                properties: colorLabel ? { Farbe: colorLabel } : {}
              }
            ]
          };
        }
      }

      return {
        mode: 'request',
        reason: 'Diese Konfiguration läuft über die Anfrage.'
      };
    }

    async function addItemsToCart(items) {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items })
      });

      if (!response.ok) {
        let message = 'Produkt konnte nicht in den Warenkorb gelegt werden.';
        try {
          const errorData = await response.json();
          if (errorData?.description) message = errorData.description;
        } catch (e) {}
        throw new Error(message);
      }

      return response.json();
    }

    async function handleCheckoutAction() {
      clearError();

      if (!validateStep(10)) return;

      try {
        const target = await resolveCartTarget();

        if (target.mode === 'request') {
          showStep(12);
          return;
        }

        await addItemsToCart(target.items);
        window.location.href = '/cart';
      } catch (error) {
        fail(error.message || 'Die Konfiguration konnte nicht verarbeitet werden.');
      }
    }

    function resetAll() {
      Object.assign(state, {
        productType: '',
        doppelstabMode: '',
        doppelstabProfile: '',
        doppelstabPostVariant: '',
        doppelstabColor: '',
        gateType: '',
        gateVariant: '',
        gateColor: '',
        series: '',
        seriesTitle: '',
        model: '',
        modelId: '',
        modelImage: '',
        height: '',
        width: '',
        install: 'nein',
        zip: '',
        materialPrice: null,
        installPrice: 0,
        totalPrice: null,
        onRequest: false,
        cornerPosts: 0,
cornerPostsPrice: 0,
cornerPostVariantId: '',

        extraGateHandle: '',
extraGateTitle: '',
extraGateImage: '',
extraGateProduct: null,
extraGateOptions: {},
extraGateVariantId: '',
extraGateVariantTitle: '',
extraGateVariantPrice: 0,

        schmuckWidth: '',
        schmuckHeight: '',
        schmuckColor: '',
        schmuckPforte: '',
        schmuckDoppeltor: '',
        schmuckSchiebetor: '',
        schmuckBriefkasten: '',
        schmuckMontage: ''
      });

      root.querySelectorAll('.is-selected').forEach((el) => el.classList.remove('is-selected'));
      root.querySelectorAll('[data-install="nein"]').forEach((el) => el.classList.add('is-selected'));

      if (heightInput) heightInput.value = '';
      if (widthInput) widthInput.value = '';
      if (gateColorInput) gateColorInput.value = '';
      if (zipInput) zipInput.value = '';
      if (cornerPostsInput) cornerPostsInput.value = '0';

      if (schmuckWidthInput) schmuckWidthInput.value = '';
      if (schmuckHeightInput) schmuckHeightInput.value = '';
      if (schmuckColorInput) schmuckColorInput.value = '';
      if (schmuckPforteInput) schmuckPforteInput.value = '';
      if (schmuckDoppeltorInput) schmuckDoppeltorInput.value = '';
      if (schmuckSchiebetorInput) schmuckSchiebetorInput.value = '';
      if (schmuckBriefkastenInput) schmuckBriefkastenInput.value = '';
      if (schmuckMontageInput) schmuckMontageInput.value = '';

      if (firstnameInput) firstnameInput.value = '';
      if (lastnameInput) lastnameInput.value = '';
      if (emailInput) emailInput.value = '';
      if (phoneInput) phoneInput.value = '';
      if (messageInput) messageInput.value = '';

      if (extraGateOptionsWrap) extraGateOptionsWrap.innerHTML = '';
if (extraGatePriceEl) extraGatePriceEl.textContent = 'Torpreis wird nach Auswahl angezeigt.';
setHidden(extraGateConfig, true);

      seriesRenderToken += 1;
      modelRenderToken += 1;

      renderSeriesCards();
      initSchmuckSelects();
      updateStep5Visibility();
      setupGateDropdowns();
      showStep(1);
      clearError();
    }

    root.querySelectorAll('[data-product-type]').forEach((btn) => {
      btn.addEventListener('click', () => {
        select('[data-product-type]', btn);
        state.productType = btn.dataset.productType;

        state.doppelstabMode = '';
        state.doppelstabProfile = '';
        state.doppelstabPostVariant = '';
        state.doppelstabColor = '';
        state.gateType = '';
        state.gateVariant = '';
        state.gateColor = '';
        state.series = '';
        state.seriesTitle = '';
        state.model = '';
        state.modelId = '';
        state.modelImage = '';
        state.height = '';
        state.width = '';
        state.install = 'nein';

        setupGateDropdowns();
        updateStep5Visibility();
        updateMobileStickyVisibility();
        autoNext();
      });
    });

    root.querySelectorAll('[data-doppelstab-mode]').forEach((btn) => {
      btn.addEventListener('click', () => {
        select('[data-doppelstab-mode]', btn);
        state.doppelstabMode = btn.dataset.doppelstabMode;
        state.doppelstabPostVariant = '';
        state.width = '';
        autoNext();
      });
    });

    root.querySelectorAll('[data-doppelstab-profile]').forEach((btn) => {
      btn.addEventListener('click', () => {
        select('[data-doppelstab-profile]', btn);
        state.doppelstabProfile = btn.dataset.doppelstabProfile;
        autoNext();
      });
    });

    root.querySelectorAll('[data-doppelstab-post-variant]').forEach((btn) => {
      btn.addEventListener('click', () => {
        select('[data-doppelstab-post-variant]', btn);
        state.doppelstabPostVariant = btn.dataset.doppelstabPostVariant;
        autoNext();
      });
    });

    root.querySelectorAll('[data-doppelstab-color]').forEach((btn) => {
      btn.addEventListener('click', () => {
        select('[data-doppelstab-color]', btn);
        state.doppelstabColor = btn.dataset.doppelstabColor;
        autoNext();
      });
    });

    root.querySelectorAll('[data-gate-type]').forEach((btn) => {
      btn.addEventListener('click', () => {
        select('[data-gate-type]', btn);
        state.gateType = btn.dataset.gateType;
        state.gateVariant = '';
        state.height = '';
        state.width = '';
        state.gateColor = '';
        setupGateDropdowns();
        autoNext();
      });
    });

    root.querySelectorAll('[data-install]').forEach((btn) => {
      btn.addEventListener('click', () => {
        select('[data-install]', btn);
        state.install = btn.dataset.install;
        updateMobilePrice();
        clearError();
      });
    });

    root.querySelectorAll('[data-extra-gate-handle]').forEach((btn) => {
  btn.addEventListener('click', () => {
    selectExtraGate(btn.dataset.extraGateHandle || '', btn);
  });
});

    nextBtn?.addEventListener('click', nextStep);
    backBtn?.addEventListener('click', prevStep);
    mobileBackBtn?.addEventListener('click', prevStep);

    mobileNextBtn?.addEventListener('click', () => {
      if (currentStep === 11) {
        handleCheckoutAction();
        return;
      }

      if (currentStep === 12) {
        submit();
        return;
      }

      if (currentStep === 13) {
        resetAll();
        return;
      }

      nextStep();
    });

    goOfferBtn?.addEventListener('click', handleCheckoutAction);
    submitBtn?.addEventListener('click', submit);
    restartBtn?.addEventListener('click', resetAll);

    
cornerPostsInput?.addEventListener('change', async () => {
  syncStateFromInputs();
  await updateCornerPostVariant();
  updateMobilePrice();
  clearError();
});    
heightInput?.addEventListener('change', () => {
      if (state.gateType === 'industry9') {
        refreshIndustry9Widths();
      }
      updateMobilePrice();
    });

    bindPriceListeners([
      widthInput,
      gateColorInput,
      zipInput,
      schmuckWidthInput,
      schmuckHeightInput,
      schmuckColorInput,
      schmuckPforteInput,
      schmuckDoppeltorInput,
      schmuckSchiebetorInput,
      schmuckBriefkastenInput,
      schmuckMontageInput
    ]);

    renderExtraGateCards();
renderSeriesCards();
initSchmuckSelects();
updateStep5Visibility();
setupGateDropdowns();
initStartCta();
showStep(1);

    window.setTimeout(updateSliderHeight, 80);
    window.addEventListener('resize', updateSliderHeight);
  });
});